import { useEffect } from 'react';
import {
  IMPRESSION_FOCUS_RESOLVED_EVENT,
  type ImpressionFocusResolvedDetail,
} from '../guestImpressionsApi';

const FIND_ATTEMPTS = 40;
const FIND_INTERVAL_MS = 50;
const HIGHLIGHT_MS = 1600;

export function ImpressionFocusBridge() {
  useEffect(() => {
    let findTimer: number | null = null;
    let highlightTimer: number | null = null;

    const stopFinding = () => {
      if (findTimer !== null) {
        window.clearInterval(findTimer);
        findTimer = null;
      }
    };

    const handleResolved = (event: Event) => {
      const detail = (event as CustomEvent<ImpressionFocusResolvedDetail>).detail;
      if (!detail?.found) return;

      stopFinding();
      let attempts = 0;
      findTimer = window.setInterval(() => {
        attempts += 1;
        const sectionTitle = document.getElementById('venue-impressions-title');
        const section = sectionTitle?.closest<HTMLElement>('.venue-detail-section');
        const card = section?.querySelector<HTMLElement>('.venue-detail-impression-card') ?? null;

        if (!card) {
          if (attempts >= FIND_ATTEMPTS) stopFinding();
          return;
        }

        stopFinding();
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });

        const previousOutline = card.style.outline;
        const previousOutlineOffset = card.style.outlineOffset;
        const previousTransition = card.style.transition;
        card.style.transition = 'outline-color 180ms ease, outline-offset 180ms ease';
        card.style.outline = '2px solid currentColor';
        card.style.outlineOffset = '4px';

        highlightTimer = window.setTimeout(() => {
          card.style.outline = previousOutline;
          card.style.outlineOffset = previousOutlineOffset;
          card.style.transition = previousTransition;
          highlightTimer = null;
        }, HIGHLIGHT_MS);
      }, FIND_INTERVAL_MS);
    };

    window.addEventListener(IMPRESSION_FOCUS_RESOLVED_EVENT, handleResolved);
    return () => {
      window.removeEventListener(IMPRESSION_FOCUS_RESOLVED_EVENT, handleResolved);
      stopFinding();
      if (highlightTimer !== null) window.clearTimeout(highlightTimer);
    };
  }, []);

  return null;
}
